import { render, staticRenderFns } from "./img-viewer.vue?vue&type=template&id=659dd4ac"
import script from "./img-viewer.vue?vue&type=script&lang=js"
export * from "./img-viewer.vue?vue&type=script&lang=js"
import style0 from "./img-viewer.vue?vue&type=style&index=0&id=659dd4ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports